export default {
      id: "big-arrow-up-usage",
      viewBox: "0 0 32 98",
      url: "../../assets/" + "sprite.svg#big-arrow-up-usage",
      toString: function () {
        return this.url;
      }
    }